import { AsyncActionHandler } from 'action-handler';
import { triggerAppSync } from 'actions/gallery';
import { markAppRemoved } from 'actions/registry';
import { triggerContinueInstall } from 'actions/install-flow';

export default new AsyncActionHandler({
  name: 'uninstall_app',
  stateProp: 'uninstallApp',
  handler: (id) => async (dispatch) => {
    await dispatch(
      triggerContinueInstall({
        show: false,
        hasBeenSeen: true,
        shouldContinue: true
      })
    );
    await dispatch(markAppRemoved(id));
    await dispatch(triggerAppSync({ force: true }));
  }
});
